import moment from "moment";
import axiosFetch from "../api/AxiosAdapter";
import Configuracao from "../misc/Configuracao";
import UsuarioStore from '../store/UsuarioStore';
import { AppStore } from "../store/AppStore";
import MensagemStore from "../store/MensagemStore";
import Ambiente from "../utils/Ambiente";
import { apresentarApiErroPadrao } from '../utils/ApiErroPadraoUtils';

class LogusService {
    loginClient;

    inicializarLogus() {
        if (!Ambiente) {
            throw new Error("Ocorreu um erro ao recuperar as configurações de ambiente");
        }
        moment.locale('pt-BR');
        const script = document.createElement('script');
        try {
            script.src = Ambiente.urlLogus + '/js/login-client.js';
            script.onerror = this.onLoginError;
            script.onload = this.onLoadApp;
            document.body.appendChild(script);
        }
        catch (e) {
            console.error(e);
        }
    }

    onLoginError = () => {
        MensagemStore.apresentarErro("Ocorreu um erro ao carregar o script de login.");
    }

    onLoadApp = async () => {
        this.loginClient = await this.construirLoginClient();
        (window as any).loginClient = this.loginClient;
        await this.loginClient.inicializar();
    }


    async construirLoginClient() {
        const response = await fetch(Ambiente.urlLogus + "/configs", { headers: { accept: 'application/json' } })
        const urlPaginaAutenticacao = await response.json();
        const settings = {
            urlPaginaAutenticacao: urlPaginaAutenticacao.urlLogin,
            urlLoginServer: Ambiente.urlLogus,
            nomeAplicacaoOrigem: Ambiente.appNome,
            versaoAplicacaoOrigem: `${Ambiente.appVersao}, ${moment(Ambiente.dataBuild).format('DD/MM/YYYY HH:mm')}`,
            sistemaAutorizacao: 'TG',
            cbAlteracaoToken: async (token, statusErro) => {
                // Callback chamado quando o token for criado ou renovado
                if (!token) {
                    this.limparStorage(statusErro);
                } else {
                    await this.configurarUsuario(token);
                }
            },
            cbErroAlteracaoToken: erro => {
                console.error(erro);
                AppStore.fecharApp();
            }
        };
        return (window as any).novoLoginClient(settings);
    }

    limparStorage = (statusErro) => {
        UsuarioStore.limpar();
        if (statusErro) {
            if (!apresentarApiErroPadrao(statusErro)) {
                MensagemStore.apresentarErro("Autenticação perdida: atualize a tela ou aguarde para efetuar novo login.");
            }
            setTimeout(() => window.location.reload(), 5000);
        } else {
            window.location.reload();
        }
    }
    async configurarUsuario(token) {
        const perfilOK = await UsuarioStore.configurarUsuario(token);
        if (perfilOK) {
            AppStore.abrirApp();
        } else {
            MensagemStore.apresentarErro("O perfil selecionado não tem autorização para acessar o Gabinete Eletrônico.");
            setTimeout(() => this.logusLogout(), 5000);
        }
    }

    logout = () => {
        AppStore.fecharApp();
    }

    logusLogout = () => {
        (window as any).loginClient && (window as any).loginClient.logout();
    }

    async traduzToken(token: string) {
        return await axiosFetch(Configuracao.urlInfoToken, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
    }

}

export default new LogusService();
